/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Portfolio-UI
 * Date: 6/24/21
 * Copyright All Rights Reserved
 */
import { FUNCTIONAL_RECOVERY_TIME_ID, REOCCUPANCY_TIME_ID, FULL_REPAIR_TIME_ID } from 'constants/performanceMetrics';

const isTimeBasedMetric = performanceMetric => [
  FUNCTIONAL_RECOVERY_TIME_ID,
  REOCCUPANCY_TIME_ID,
  FULL_REPAIR_TIME_ID,
].includes(performanceMetric);

export default isTimeBasedMetric;



// WEBPACK FOOTER //
// ./js/support/isTimeBasedMetric.js